/* ═══════════════════════════════════════════════════════════════════════════
   LUGHATI ENHANCED JS v2.1 - Fixed
   التركيز: الوضوح أولاً، الأنيميشن ثانياً
   ═══════════════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ───────────────────────────────────────────────────────────────────────
     مبدأ أساسي:
     • النصوص دائماً واضحة وقابلة للقراءة (opacity: 1)
     • الأنيميشن فقط للعناصر المحددة بـ data-animate
     • لا نطبق opacity على containers كبيرة أبداً
     ─────────────────────────────────────────────────────────────────────── */

  // ─────────────────────────── PARALLAX (Hero فقط) ─────────────────────────── //
  function initParallax() {
    const heroVisual = document.querySelector('.lh-hero__visual');
    const heroPattern = document.querySelector('.lh-hero__bg-pattern');
    
    if (!heroVisual && !heroPattern) return;

    let ticking = false;
    
    function updateParallax() {
      const scrollY = window.scrollY;
      const heroSection = document.querySelector('.lh-hero');
      
      if (!heroSection) return;
      
      const heroHeight = heroSection.offsetHeight;
      
      if (scrollY < heroHeight) {
        if (heroVisual) {
          heroVisual.style.transform = `translateY(${scrollY * 0.15}px)`;
        }
        
        if (heroPattern) {
          heroPattern.style.transform = `translateY(${scrollY * 0.3}px)`;
        }
      }
      
      ticking = false;
    }
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  // ─────────────────────────── SCROLL ANIMATIONS (محدود فقط) ─────────────────────────── //
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    
    if (!animatedElements.length || !('IntersectionObserver' in window)) {
      animatedElements.forEach(el => el.classList.add('lh-is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.dataset.animateDelay || '0');
          
          setTimeout(() => {
            entry.target.classList.add('lh-is-visible');
          }, delay);
          
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -80px 0px'
    });

    animatedElements.forEach(el => observer.observe(el));
  }

  // ─────────────────────────── SMOOTH SCROLL ─────────────────────────── //
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href === '#' || href.length < 2) return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const offset = 80;
          const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
      });
    });
  }

  // ─────────────────────────── SCROLL PROGRESS BAR ─────────────────────────── //
  function initScrollProgress() {
    const progressBar = document.createElement('div');
    progressBar.className = 'lh-scroll-progress';
    document.body.appendChild(progressBar);
    
    let ticking = false;
    
    function updateProgress() {
      const winHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = winHeight > 0 ? (window.scrollY / winHeight) * 100 : 0;
      progressBar.style.width = scrolled + '%';
      ticking = false;
    }
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });
  }

  // ─────────────────────────── FLOATING LETTERS ANIMATION ─────────────────────────── //
  function initFloatingLetters() {
    const letters = document.querySelectorAll('.lh-hero__letter');
    letters.forEach((letter, index) => {
      letter.style.animationDelay = `${index * 0.5}s`;
    });
  }

  // ─────────────────────────── ANALYTICS WRAPPER ─────────────────────────── //
  function trackLughatiEvent(name, params) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, params);
      }
      if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (error) {
      if (window.console && console.warn) {
        console.warn('Lughati analytics skipped:', name, error);
      }
    }
  }
  // Expose for inline handlers / debugging without blocking navigation.
  window.trackLughatiEvent = trackLughatiEvent;

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1600 });
      return;
    }
    window.setTimeout(callback, 250);
  }

  // ─────────────────────────── TRACKED INTERACTIONS ─────────────────────────── //
  function initTrackedInteractions() {
    document.querySelectorAll('[data-lh-track]').forEach((el) => {
      el.addEventListener('click', () => {
        const name = el.getAttribute('data-lh-track');
        if (!name) return;
        const params = {};
        for (const attr of el.attributes) {
          if (attr.name.startsWith('data-lh-') && attr.name !== 'data-lh-track') {
            params[attr.name.replace('data-lh-', '')] = attr.value;
          }
        }
        trackLughatiEvent(name, params);
      }, { passive: true });
    });
  }

  // ─────────────────────────── LANGUAGE TOGGLE ─────────────────────────── //
  const LANGUAGE_ROUTED_PAGE_HANDLES = new Set([
    'policies',
    'faq',
    'faqs',
    'questions',
    'frequently-asked-questions',
    'shipping-policy',
    'returns-refunds-policy',
    'privacy-policy',
    'terms-of-service',
    'ar-usage-policy',
    'device-policy',
    'support-policy',
    'institutional-use-policy'
  ]);

  function getUrlLang() {
    try {
      const lang = new URL(window.location.href).searchParams.get('lang');
      return lang === 'ar' || lang === 'en' ? lang : null;
    } catch (e) {
      return null;
    }
  }

  function getLanguageRoutedPageHandle() {
    const match = (window.location.pathname || '').match(/^\/pages\/([^/?#]+)\/?$/);
    return match && LANGUAGE_ROUTED_PAGE_HANDLES.has(match[1]) ? match[1] : null;
  }

  function syncLanguageRoutedUrl(lang) {
    if (lang !== 'ar' && lang !== 'en') return;
    if (!getLanguageRoutedPageHandle()) return;

    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('lang') === lang) return;
      url.searchParams.set('lang', lang);
      window.location.assign(url.toString());
    } catch (e) {}
  }

  // Set by layout/theme.liquid when the template declares its own language.
  // Such a page renders only that one language block.
  function isLangLocked() {
    return document.documentElement.getAttribute('data-lh-lang-locked') === '1';
  }

  function getServerLang() {
    return (document.documentElement.getAttribute('data-lh-lang') || 'en').toLowerCase() === 'ar' ? 'ar' : 'en';
  }

  function getCurrentLang() {
    // On a locked page the server already resolved the language, and it is the
    // only one on the page — ?lang must not move it or the page goes blank.
    if (isLangLocked()) return getServerLang();
    const urlLang = getUrlLang();
    if (urlLang) return urlLang;
    return getServerLang();
  }

  function persistLang(lang) {
    try {
      const oneYear = 60 * 60 * 24 * 365;
      document.cookie = 'lh_lang=' + lang + '; path=/; max-age=' + oneYear + '; samesite=lax';
    } catch (e) {}
  }

  function applyLang(lang, options = {}) {
    if (lang !== 'ar' && lang !== 'en') lang = 'en';
    const html = document.documentElement;
    html.setAttribute('data-lh-lang', lang);
    html.setAttribute('lang', lang);
    html.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    // A locked page must never write the sitewide cookie as a load-time side
    // effect — simply visiting the Arabic page would otherwise switch the
    // whole store to Arabic for that visitor. Only an explicit switcher click
    // persists a choice. Unlocked pages keep writing it on load as before.
    if (options.persist || !isLangLocked()) {
      persistLang(lang);
    }
    // Sync language switcher button pressed state.
    document.querySelectorAll('[data-lh-set-lang]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-lh-set-lang') === lang ? 'true' : 'false');
    });
    if (options.syncPolicyUrl) syncLanguageRoutedUrl(lang);
    if (!options.silent) {
      trackLughatiEvent('language_change', { lang: lang });
    }
  }

  function initLanguageToggle() {
    // Initialise pressed state on load.
    applyLang(getCurrentLang(), { silent: true });
    document.querySelectorAll('[data-lh-set-lang]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const next = btn.getAttribute('data-lh-set-lang');
        if (isLangLocked()) {
          // A locked page renders only its own template's language, so
          // switching in place would hide the single block it has and leave
          // the page blank. Record the choice and hand off to the home page,
          // which renders both languages and honours the cookie. The sibling
          // page's URL is deliberately not guessed at: nothing in the theme
          // records which handle carries the opposite template.
          persistLang(next);
          trackLughatiEvent('language_change', { lang: next });
          window.location.assign('/');
          return;
        }
        applyLang(next, { syncPolicyUrl: true, persist: true });
      });
    });
  }

  // ─────────────────────────── CURRENCY SELECTOR ─────────────────────────── //
  function initCurrencySelector() {
    document.querySelectorAll('[data-lh-currency-select]').forEach((select) => {
      select.addEventListener('change', () => {
        if (!/^[A-Z]{2}$/.test(select.value || '')) return;
        const form = select.closest('form');
        if (form) {
          trackLughatiEvent('currency_change', { country: select.value });
          form.submit();
        }
      });
    });
    // Close <details data-lh-currency> when clicking truly outside.
    // (Don't fight the native <summary> toggle — only close when the click
    //  lands outside the entire <details>.)
    document.addEventListener('click', (e) => {
      document.querySelectorAll('details[data-lh-currency][open]').forEach((d) => {
        if (d.contains(e.target)) return;
        d.removeAttribute('open');
      });
    });
  }

  // ─────────────────────────── ACTIVE NAV STATE ─────────────────────────── //
  function initActiveNav() {
    const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
    document.querySelectorAll('.lh-nav-pill, .lh-footer__list a').forEach((link) => {
      const href = (link.getAttribute('href') || '').replace(/\/+$/, '') || '/';
      if (!href || href === '#' || href.indexOf('http') === 0) return;
      if (href === path || (href !== '/' && path.indexOf(href) === 0)) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
      }
    });
  }

  // ─────────────────────────── BACK-TO-TOP BUTTON ─────────────────────────── //
  function initBackToTop() {
    if (document.querySelector('.lh-back-to-top')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lh-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 15 12 9 18 15"/></svg>';
    document.body.appendChild(btn);

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        btn.classList.toggle('is-visible', window.scrollY > 360);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      trackLughatiEvent('back_to_top_click');
    });
  }

  // ─────────────────────────── POLICIES SCROLL SPY ─────────────────────────── //
  function initPoliciesScrollSpy() {
    const policyRoot = document.querySelector('.lh-policy[data-lh-policy="all"]');
    if (!policyRoot) return;
    const accordionItems = policyRoot.querySelectorAll('.lh-policy-faq details[id]');
    const openPolicyFromHash = () => {
      const id = (window.location.hash || '').replace(/^#/, '');
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !target.matches('.lh-policy-faq details')) return;
      target.open = true;
      window.requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    };
    if (accordionItems.length) {
      openPolicyFromHash();
      window.addEventListener('hashchange', openPolicyFromHash);
    }
    const chips = policyRoot.querySelectorAll('.lh-policy__related-chip[href^="#"]');
    const sections = [];
    chips.forEach((chip) => {
      const id = (chip.getAttribute('href') || '').replace(/^#/, '');
      const el = id && document.getElementById(id);
      if (el) sections.push({ chip, el, id });
    });
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just mark the first one active.
      sections[0].chip.classList.add('is-active');
      return;
    }

    const setActive = (activeId) => {
      sections.forEach(({ chip, id }) => {
        chip.classList.toggle('is-active', id === activeId);
      });
    };

    // Use a rootMargin band near the top of the viewport so the active item
    // updates as the heading enters the upper third of the screen.
    const io = new IntersectionObserver((entries) => {
      // Pick the entry whose top is closest to (but below) the trigger line.
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (visible) setActive(visible.target.id);
    }, {
      rootMargin: '-120px 0px -65% 0px',
      threshold: 0
    });
    sections.forEach(({ el }) => io.observe(el));

    // Smooth-scroll into anchors with offset (so the title isn't hidden under
    // the sticky header).
    chips.forEach((chip) => {
      chip.addEventListener('click', (e) => {
        const id = (chip.getAttribute('href') || '').replace(/^#/, '');
        const target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
        setActive(id);
        trackLughatiEvent('policy_nav_click', { policy: id });
      });
    });

    // Honour initial hash on load.
    if (window.location.hash) {
      const id = window.location.hash.replace(/^#/, '');
      if (sections.some((s) => s.id === id)) setActive(id);
    } else {
      setActive(sections[0].id);
    }
  }

  // ─────────────────────────── MAGNETIC BUTTON HOVER ─────────────────────────── //
  function initMagneticButtons() {
    const supportsHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!supportsHover || prefersReduced) return;
    document.querySelectorAll('.lh-button--primary').forEach((btn) => {
      let raf = null;
      btn.addEventListener('mousemove', (e) => {
        if (raf) cancelAnimationFrame(raf);
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        raf = window.requestAnimationFrame(() => {
          btn.style.transform = `translate(${x * 0.08}px, ${y * 0.12}px)`;
        });
      });
      btn.addEventListener('mouseleave', () => {
        if (raf) cancelAnimationFrame(raf);
        btn.style.transform = '';
      });
    });
  }

  // ─────────────────────────── PRODUCT INTERACTIONS ─────────────────────────── //
  function initProductGallery() {
    const main = document.querySelector('[data-lh-product-main]');
    const thumbs = document.querySelectorAll('[data-lh-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.getAttribute('data-lh-thumb');
        if (!src) return;
        main.setAttribute('src', src);
        main.removeAttribute('srcset');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  }

  function initProductQuantity() {
    document.querySelectorAll('[data-lh-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      const max = parseInt(input.getAttribute('max'), 10) || 99;
      const clamp = (n) => Math.max(min, Math.min(max, n));

      wrap.querySelectorAll('[data-lh-qty-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.getAttribute('data-lh-qty-step'), 10) || 0;
          const current = parseInt(input.value, 10);
          const base = Number.isFinite(current) ? current : min;
          input.value = clamp(base + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Sanitise direct typing — strip non-digits and re-clamp on blur.
      input.addEventListener('blur', () => {
        const n = parseInt((input.value || '').replace(/[^\d]/g, ''), 10);
        input.value = clamp(Number.isFinite(n) ? n : min);
      });
    });
  }

  // ─────────────────────────── INIT ─────────────────────────── //
  function init() {
    initLanguageToggle();
    initCurrencySelector();
    initActiveNav();
    initScrollAnimations();
    initSmoothScroll();
    initProductGallery();
    initProductQuantity();
    runWhenIdle(() => {
      initParallax();
      initScrollProgress();
      initFloatingLetters();
      initTrackedInteractions();
      initBackToTop();
      initMagneticButtons();
      initPoliciesScrollSpy();
      // Re-run scroll-spy if the policy fallback JS injected content after init.
      window.setTimeout(initPoliciesScrollSpy, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
